import {
  PULL_REQUESTED_PDF,
  STOP_PULLING_REQUESTED_PDF,
} from 'src/redux/constants';
import type { ViewAction, ViewActionPayload } from 'src/redux/viewState/types';

export const pullPdf = (subAction: ViewActionPayload = {}): ViewAction => {
  return {
    type: PULL_REQUESTED_PDF,
    subAction,
  };
};

export const stopPullingPdf = (): ViewAction => {
  return {
    type: STOP_PULLING_REQUESTED_PDF,
  };
};
